import { matchPath } from 'react-router-dom';

/**
 * Routes emprunteur portant l'id du PROJET d'emprunt (projetEmpruntId) dans l'URL.
 */
// NB : pas de param optionnel (`:borrowerId?`) — les segments optionnels ne sont gérés
// que par l'arbre de <Routes> (matchRoutes explose les variantes), PAS par matchPath,
// qui renvoie null sur un pattern contenant `?` (vérifié en react-router-dom 6.10).
// On déclare donc explicitement les variantes avec et sans borrowerId.
const BORROWER_PROJECT_ROUTES = [
  '/simulation/tarification/emprunteur/:borrowerProjectId/:borrowerId',
  '/simulation/tarification/emprunteur/:borrowerProjectId',
  '/simulation/profilage/emprunteur/projet/:borrowerProjectId',
  '/simulation/contractualisation/borrower/:borrowerProjectId/:borrowerId/:quoteId'
];

/**
 * Id du **projet d'emprunt** (projetEmpruntId / borrowerProjectId) courant, extrait de
 * l'URL — **la seule source de vérité** (Redux n'a que `riskId` = emprunteurId, un projet
 * contient plusieurs risques).
 *
 * On lit `window.location.pathname` et NON `useLocation()` : les formulaires sont ouverts
 * dans des panneaux (usePanel) rendus HORS du `<Router>` — `useLocation()`/`useParams()`
 * y lèvent une erreur (écran blanc) ou renvoient un mauvais chemin. `window.location`
 * fonctionne partout et donne le vrai chemin du navigateur.
 *
 * Préférer malgré tout la prop `borrowerProjectId` passée par l'ouvrant quand elle existe
 * (cf. useMinimalBorrowerForm / useBorrowerInsuredForm) ; cet helper est le repli.
 */
export const getBorrowerProjectIdFromUrl = (): string | undefined => {
  const pathname =
    typeof window !== 'undefined' && window.location ? window.location.pathname : '';
  for (const pattern of BORROWER_PROJECT_ROUTES) {
    const id = matchPath(pattern, pathname)?.params?.borrowerProjectId;
    if (id) return id;
  }
  return undefined;
};

/**
 * Variante hook (nom conservé pour les appelants existants). Ne dépend d'aucun contexte
 * Router : sûr même dans un panneau portalisé.
 */
export const useBorrowerProjectId = (): string | undefined => getBorrowerProjectIdFromUrl();
